import { startCase } from 'lodash';

import { FeeType } from '@willow/types-iso';

export function getFeeLabelFromType(type: FeeType): string {
  switch (type) {
    case 'NON_SUFFICIENT_FUNDS':
      return 'Non-Sufficient Funds'; // boo hyphens
    case 'LATE':
    case 'DRAW':
    case 'EXTENSION':
    case 'PAYOFF':
    case 'PREPAYMENT_PENALTY':
    case 'LEGAL':
    case 'LIEN_RELEASE':
    case 'PENDING_PAYMENT_AT_PAYOFF':
    case 'TERMINATION':
    case 'OTHER':
    // Elite fees
    case 'ADMIN':
    case 'DEBOARDING':
    case 'LOAN_MODIFICATION':
    case 'ONBOARDING':
    case 'RECORDING':
    case 'RUSH':
    case 'VERIFICATION_OF_MORTGAGE':
    case 'WIRE':
    case 'TAX':
    case 'PRINCIPAL_LATE':
    case 'PAYOFF_REVISION':
    case 'DOCUMENT':
    case 'CREDIT_CARD_PROCESSING':
    default: // assertNever some day?
      return startCase(type.toLowerCase());
  }
}
